module.exports = __webpack_public_path__ + "img/login-bgc-3.b125ece5.png";